// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".re_login_modal--text[data-v-64e1a4bc]{line-height:1.3}", "",{"version":3,"sources":["webpack://./resources/client/modules/auth/components/ContinueSessionModal.vue"],"names":[],"mappings":"AAGA,uCACE,eAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.re_login_modal--text {\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
